<template>
  <div>
    <b-card no-body class="rounded-0 mb-0">
      <b-tabs card>
        <b-tab title="Contact Details" active>
          <div class="ml-3 mr-3 mb-3">
            <div
              style="display: grid; grid-template-columns: repeat(15, 1fr); grid-gap: 0.5rem; width: 1200px;"
            >
              <b-form-group label="Prefix" style="grid-column: 1">
                <b-form-input v-model="copy.prefix"></b-form-input>
              </b-form-group>

              <b-form-group label="First Name *" style="grid-column: 2/4">
                <b-form-input
                  :disabled="!isAddContactForm"
                  :state="$v.copy.firstName.$error ? $v.copy.firstName.required : null"
                  v-model="copy.firstName"
                  aria-required="10px"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Middle Name" style="grid-column: 4/6">
                <b-form-input
                  :disabled="!isAddContactForm"
                  v-model="copy.middleName"
                  aria-required="10px"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Last Name *" style="grid-column: 6/8">
                <b-form-input
                  :disabled="!isAddContactForm"
                  :state="$v.copy.lastName.$error ? $v.copy.lastName.required : null"
                  v-model="copy.lastName"
                  aria-required="10px"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Suffix">
                <b-form-input v-model="copy.suffix" aria-required="10px" autocomplete="off"></b-form-input>
              </b-form-group>

              <b-form-group label="Gender" style="grid-column: 10">
                <b-form-select v-model="copy.gender">
                  <option value="M">Male</option>
                  <option value="F">Female</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Date Of Birth" style="grid-column: 11/13">
                <b-form-datepicker
                  id="date-of-birth"
                  aria-required="10px"
                  placeholder="mm/dd/yyyy"
                  size="sm"
                  v-model="copy.birthDate"
                  today-button
                  reset-button
                  close-button
                  :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
                />
              </b-form-group>

              <b-form-group label="SSN" style="grid-column: 13/14">
                <b-form-input
                  :type="ssnField"
                  v-model="copy.ssn"
                  aria-required="10px"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 14/16"
                @change="switchVisibility"
              >Hide SSN</b-form-checkbox>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 1"
                v-model="copy.active"
              >Active</b-form-checkbox>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 2/4"
                v-model="copy.isPrimary"
              >Primary Contact</b-form-checkbox>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4/6"
                v-model="copy.canAccessPortal"
              >Grant Portal Access</b-form-checkbox>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 6/9"
                v-model="copy.canSignForCompany"
              >Has Signature Authority</b-form-checkbox>
            </div>
          </div>
          <div class="d-flex mb-3">
            <!-- PERSONAL DETAILS -->
            <!-- LEFT CONTAINER -->
            <div
              class="ml-3 mr-3"
              style="display: grid; grid-template-columns: auto min-content; grid-template-rows: repeat(7, 40px); grid-gap: 0.5rem; width: 1200px;"
            >
              <b-form-group label="Personal Details" style="font-size: large; grid-column: 1/3"></b-form-group>
              <b-form-group label="Address 1" style="grid-column: 1/6">
                <b-form-input v-model="copy.address1" autocomplete="off"></b-form-input>
              </b-form-group>

              <b-form-group label="Address 2" style="grid-column: 1/6">
                <b-form-input v-model="copy.address2" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="City" style="grid-column: 1/3">
                <b-form-input v-model="copy.city" autocomplete="off"></b-form-input>
              </b-form-group>
              <!-- State -->
              <b-form-group label="State" style="grid-column: 3/4">
                <state-selector :stateId="copy.state" @onChange="onStateChange"></state-selector>
              </b-form-group>

              <b-form-group label="Zip Code" style="grid-column: 4/6">
                <b-form-input
                  v-mask="'#####-####'"
                  placeholder="#####-####"
                  :state="$v.copy.zipcode.$error ? $v.copy.zipcode.isValidZipCode : null"
                  v-model="copy.zipcode"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Email" style="grid-column: 1/4">
                <b-form-input
                  :state="$v.copy.email.$error ? !$v.copy.email.$error : null"
                  v-model="copy.email"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4/6"
                v-model="copy.email1DoNotEmail"
              >Do not email</b-form-checkbox>

              <b-form-group label="Alternate Email" style="grid-column: 1/4">
                <b-form-input
                  :state="$v.copy.email2.$error ? !$v.copy.email2.$error : null"
                  v-model="copy.email2"
                ></b-form-input>
              </b-form-group>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4/6"
                v-model="copy.email2DoNotEmail"
              >Do not email</b-form-checkbox>

              <b-form-group label="Phone" style="grid-column: 1/2">
                <b-form-input
                  v-mask="'(###) ###-####'"
                  placeholder="(###) ###-####"
                  :state="$v.copy.phoneNumber.$error ? $v.copy.phoneNumber.isValidPhone : null"
                  v-model="copy.phoneNumber"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Ext" style="grid-column: 2/3">
                <b-form-input v-model="copy.phone1Extn" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="Type" style="grid-column: 3/4">
                <phone-type-selector
                  :phoneTypeId="copy.phone1TypeId"
                  :phoneTypesData="phoneTypes"
                  @onChange="onPhoneTypeChange($event, 'phone1TypeId')"
                />
              </b-form-group>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4"
                v-model="copy.phone1Preferred"
              >Preferred</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 5"
                v-model="copy.phone1DoNotText"
              >Do not text</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 6"
                v-model="copy.phone1DoNotCall"
              >Do not call</b-form-checkbox>

              <b-form-group label="Phone" style="grid-column: 1/2">
                <b-form-input
                  v-mask="'(###) ###-####'"
                  placeholder="(###) ###-####"
                  :state="$v.copy.phone2.$error ? $v.copy.phone2.isValidPhone : null"
                  v-model="copy.phone2"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Ext" style="grid-column: 2/3">
                <b-form-input v-model="copy.phone2Extn" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="Type" style="grid-column: 3/4">
                <phone-type-selector
                  :phoneTypeId="copy.phone2TypeId"
                  :phoneTypesData="phoneTypes"
                  @onChange="onPhoneTypeChange($event, 'phone2TypeId')"
                />
              </b-form-group>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4"
                v-model="copy.phone2Preferred"
              >Preferred</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 5"
                v-model="copy.phone2DoNotText"
              >Do not text</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 6"
                v-model="copy.phone2DoNotCall"
              >Do not call</b-form-checkbox>

              <b-form-group label="Fax" style="grid-column: 1/2">
                <b-form-input
                  v-mask="'(###) ###-####'"
                  placeholder="(###)###-####"
                  :state="$v.copy.fax.$error ? $v.copy.fax.isValidFax : null"
                  v-model="copy.fax"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
            </div>

            <!-- EMPLOYMENT DETAILS -->
            <!-- RIGHT CONTAINER -->

            <div
              class="ml-3 mr-3"
              style="display: grid; grid-template-columns: auto min-content; grid-template-rows: repeat(7, 40px); grid-gap: 0.5rem; width: 1200px;"
            >
              <b-form-group label="Employment Details" style="font-size: large; grid-column: 1/3"></b-form-group>

              <b-form-group label="Reports To" style="grid-column: 1/4">
                <b-form-select v-model="copy.parentId">
                  <template v-slot:first>
                    <option :value="null" disabled>-- Select Reports To--</option>
                  </template>

                  <option
                    v-for="contactLookup in contactLookupsData"
                    :key="contactLookup.id"
                    :value="contactLookup.id"
                  >{{ contactLookup.text }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-group label="Business Unit" style="grid-column: 4/7">
                <b-form-select v-model="copy.companyRegionId">
                  <template v-slot:first>
                    <option :value="null" disabled>-- Select Business Unit--</option>
                  </template>

                  <option
                    v-for="companyBusinessUnit in companyBusinessUnits"
                    :key="companyBusinessUnit.id"
                    :value="companyBusinessUnit.id"
                  >{{ companyBusinessUnit.name }}</option>
                </b-form-select>
              </b-form-group>

              <b-form-group label="Title *" style="grid-column: 1/4">
                <b-form-input
                  :state="$v.copy.workTitle.$error ? $v.copy.workTitle.required : null"
                  v-model="copy.workTitle"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Location *" style="grid-column: 1/4">
                <b-form-select
                  :state="$v.copy.companyLocationId.$error ? $v.copy.companyLocationId.required : null"
                  v-model="copy.companyLocationId"
                >
                  <template v-slot:first>
                    <option :value="null" disabled>-- Select location --</option>
                  </template>

                  <option
                    v-for="location in locations"
                    :key="location.id"
                    :value="location.id"
                  >{{ location.name }}</option>
                </b-form-select>
                <!-- <b-form-input v-model="copy.location" autocomplete="off"></b-form-input> -->
              </b-form-group>

              <b-form-group label="Email *" style="grid-column: 1/4">
                <b-form-input
                  :state="$v.copy.workEmail.$error ? !$v.copy.workEmail.$error : null"
                  v-model="copy.workEmail"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4/6"
                v-model="copy.workEmailDoNotEmail"
              >Do not email</b-form-checkbox>

              <b-form-group label="Alternate Email" style="grid-column: 1/4">
                <b-form-input
                  :state="$v.copy.workEmail2.$error ? !$v.copy.workEmail2.$error : null"
                  v-model="copy.workEmail2"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>

              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4/6"
                v-model="copy.workEmail2DoNotEmail"
              >Do not email</b-form-checkbox>

              <b-form-group label="Phone *" style="grid-column: 1/2">
                <b-form-input
                  v-mask="'(###) ###-####'"
                  placeholder="(###) ###-####"
                  :state="$v.copy.workPhone1.$error ? $v.copy.workPhone1.isValidPhone : null"
                  v-model="copy.workPhone1"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="Ext" style="grid-column: 2/3">
                <b-form-input v-model="copy.workPhone1Extn" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="Type *" style="grid-column: 3/4">
                <b-form-select
                  :state="$v.copy.workPhone1TypeId.$error ? $v.copy.workPhone1TypeId.isValidPhoneType : null"
                  v-model="copy.workPhone1TypeId"
                >
                  <template v-slot:first>
                    <option :value="null">Select</option>
                  </template>
                  <option
                    v-for="phnType in phoneTypes"
                    :key="phnType.id"
                    :value="phnType.id"
                  >{{ phnType.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4"
                v-model="copy.workPhone1Preferred"
              >Preferred</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 5"
                v-model="copy.workPhone1DoNotText"
              >Do not text</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 6"
                v-model="copy.workPhone1DoNotCall"
              >Do not call</b-form-checkbox>

              <b-form-group label="Phone" style="grid-column: 1/2">
                <b-form-input
                  v-mask="'(###) ###-####'"
                  placeholder="(###) ###-#### "
                  :state="$v.copy.workPhone2.$error ? $v.copy.workPhone2.isValidPhone : null"
                  v-model="copy.workPhone2"
                  autocomplete="off"
                ></b-form-input>
              </b-form-group>
              <b-form-group label="Ext" style="grid-column: 2/3">
                <b-form-input v-model="copy.workPhone2Extn" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="Type" style="grid-column: 3/4">
                <b-form-select
                  v-model="copy.workPhone2TypeId"
                  :state="$v.copy.workPhone2TypeId.$error ? $v.copy.workPhone2TypeId.isValidPhoneType : null"
                >
                  <template v-slot:first>
                    <option :value="null">Select</option>
                  </template>
                  <option
                    v-for="phnType in phoneTypes"
                    :key="phnType.id"
                    :value="phnType.id"
                  >{{ phnType.name }}</option>
                </b-form-select>
              </b-form-group>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 4"
                v-model="copy.workPhone2Preferred"
              >Preferred</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 5"
                v-model="copy.workPhone2DoNotText"
              >Do not text</b-form-checkbox>
              <b-form-checkbox
                class="d-flex align-items-center"
                style="grid-column: 6"
                v-model="copy.workPhone2DoNotCall"
              >Do not call</b-form-checkbox>

              <b-form-group label="Fax" style="grid-column: 1/2">
                <b-form-input
                  v-mask="'(###) ###-####'"
                  placeholder="(###)###-####"
                  v-model="copy.workFax"
                  autocomplete="off"
                  :state="$v.copy.workFax.$error ? $v.copy.workFax.isValidFax : null"
                ></b-form-input>
              </b-form-group>

              <b-form-group label="LinkedIn" style="grid-column: 2/5">
                <b-form-input v-model="copy.linkedin" autocomplete="off"></b-form-input>
              </b-form-group>
              <b-form-group label="Skype" style="grid-column: 5/7">
                <b-form-input v-model="copy.skype" autocomplete="off"></b-form-input>
              </b-form-group>
            </div>
          </div>
          <div class="ml-3 mr-3 mb-3">
            <div>
              <b-form-group label="Contact Role(s)">
                <b-form-checkbox-group v-model="selectedContactRoles">
                  <b-form-checkbox
                    v-for="contactRole in contactRoleTypes"
                    :key="contactRole.id"
                    :value="contactRole.id"
                  >{{contactRole.name}}</b-form-checkbox>
                  <b-form-invalid-feedback
                    :state="$v.selectedContactRoles.$error
                  ? $v.selectedContactRoles.length === 0 
                  : null"
                  >Please select at least one role.</b-form-invalid-feedback>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
          </div>
        </b-tab>
        <b-tab title="Contact Notes">
          <div class="ml-3 mr-3 mb-3">
            <div
              style="display: grid; grid-template-columns: repeat(10, 1fr); grid-gap: 0.5rem; width: 1200px;"
            >
              <b-form-group label="Notes" style="grid-column: 1/7">
                <b-form-textarea v-model="noteModel"></b-form-textarea>
              </b-form-group>
              <b-button
                size="sm"
                @click="saveNotes()"
                :disabled="isAddNotesValid"
                style="grid-column: 6/7"
              >Add Notes</b-button>
            </div>
            <div class="mt-2">
              <grid
                has-delete
                has-pagination
                grid-id="notes-grid"
                :fields="noteFields"
                :items="notes"
                :get-items-function="getContactNotesData"
                @delete="deleteNote"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import _ from 'lodash';
import { mapState, mapActions, mapGetters } from 'vuex';
import Grid from '@/shared/components/Grid';
import StateSelector from '@/shared/components/StateSelector';
import PhoneTypeSelector from '@/shared/components/PhoneTypeSelector';
import { required, email } from 'vuelidate/lib/validators';
import { REGEX } from '@/shared/constants';

//?pageNumber=1&pageSize=10&sortBy=id&sortOrder=ASC&filters={'statusId':null,'dateFrom':null,'dateTo':null}
export default {
  components: {
    Grid,
    StateSelector,
    PhoneTypeSelector
  },
  props: ['companyId', 'contact', 'updateCompanyContact', 'contactRoleTypes'],
  data() {
    return {
      copy: {
        companyRegionId: null,
        companyLocationId: null,
        phoneType1: null,
        businessUnit: null,
        workPhone1TypeId: null,
        workPhone2TypeId: null
      },
      contactLookupsData: [],
      primaryContact: [],
      checkedRowItemIds: [],
      contactRoles: [],
      spObj: {},
      isSameShipping: false,
      isSameMailing: false,
      notes: [],
      addedNotes: [],
      deleteNotes: [],
      noteModel: '',
      noteFields: [
        { key: 'commands', label: '', tdClass: 'grid-commands-width-1' },
        { key: 'notes', label: 'Note', sortable: true },
        { key: 'user', label: 'By', sortable: true },
        { key: 'date', label: 'Date', sortable: true }
      ],
      flagId: 0,
      contactsOptions: [],
      ssnField: 'number',
      selectedContactRoles: []
    };
  },
  watch: {
    updateCompanyContact(val) {
      const nObj = Object.assign({}, this.spObj, this.copy);
      this.spObj = nObj;
      this.spObj.companyId = this.companyId;
      this.spObj.active = this.showActive ? this.copy.active : true;
      this.spObj.notesArr = this.addedNotes;
      this.spObj.notesDelete = this.deleteNotes;
      this.saveCompanyContactRecord(this.spObj);
    },
    contactRoles(val) {
      this.spObj.contactRoleAsText = val;
    },
    selectedContactRoles(val) {
      this.spObj.selectedContactRoles = val;
    }
  },
  computed: {
    ...mapState('contacts', [
      'contacts',
      'contactNotes',
      'companyBusinessUnits',
      'contactLookups'
    ]),
    ...mapState('companies', ['locations']),
    ...mapState('account', ['phoneTypes']),
    isAddNotesValid() {
      return this.noteModel === null || this.noteModel.match(/^ *$/) !== null;
    },
    isAddContactForm() {
      return Object.keys(this.contact).length == 0;
    }
  },
  methods: {
    //...mapMutations()
    ...mapActions('contacts', [
      'saveCompanyContactRecord',
      'getContactNotes',
      'saveContactNotes',
      'deleteContactNote'
    ]),

    switchVisibility(e) {
      this.ssnField = e ? 'password' : 'number';
    },

    setFormValues() {
      const nObj = Object.assign({}, this.copy, this.contact);
      this.copy = nObj;

      // this.copy.birthDate = new Date();
      if (this.contact.contactRolesAsIds) {
        this.selectedContactRoles = this.contact.contactRolesAsIds.split(',');
      }

      this.contactsOptions = this.convertToFormSelectObj(this.contacts, {
        value: 'id',
        firstName: 'firstName',
        lastName: 'lastName'
      });

      if (this.isAddContactForm) {
        this.contactLookupsData = this.contactLookups;
      } else {
        this.contactLookupsData = this.contactLookups.filter(
          item => item.id != this.copy.id
        );
      }
    },

    onStateChange(val) {
      if (val) {
        this.copy.physicalState = val.abbr;
        this.copy.state = val.abbr;
      }
    },

    onPhoneTypeChange(phnType, propToUpdate) {
      if (phnType) {
        this.copy[propToUpdate] = phnType.id;
      } else {
        this.copy[propToUpdate] = null;
      }
    },

    async saveNotes() {
      let noteObj = {
        notes: this.noteModel,
        user: 'Test User', // will change with the logged in user
        date: new Date().toLocaleDateString()
      };

      this.notes.push(noteObj);
      this.noteModel = '';

      if (this.isAddContactForm) {
        this.addedNotes.push(noteObj);
      } else {
        let obj = {
          id: this.contact.id,
          notes: noteObj.notes
        };

        await this.saveContactNotes(obj);
      }
    },

    async getContactNotesData() {
      if (!this.isAddContactForm) {
        await this.getContactNotes(this.contact.id);

        this.notes = this.contactNotes;
      }
    },

    convertToFormSelectObj(arr, { value, firstName, lastName }) {
      let convertedObjArr = [];

      arr.forEach(a => {
        if (this.isValidName(a[firstName]) || this.isValidName(a[lastName])) {
          let name = a[firstName] + ' ' + a[lastName];
          convertedObjArr.push({ value: a[value], text: name });
        }
      });

      return convertedObjArr;
    },

    isValidName(name) {
      return !_.isEmpty(name) && !_.isNull(name) && name != ' ';
    },

    deleteNote(e) {
      let i = this.notes.findIndex(i => i.notes === e.notes);
      if (i > -1) {
        this.deleteNotes.push(this.notes[i].id);
        this.notes.splice(i, 1);
      }

      let j = this.addedNotes.findIndex(i => i.notes === e.notes);
      if (j > -1) {
        this.addedNotes.splice(j, 1);
      }

      let k = this.contactNotes.findIndex(i => i.notes === e.notes);
      if (k > -1) {
        this.deleteContactNote(this.contactNotes[k].id);
      }
    },
    phoneValidation(phone) {
      if (!phone) {
        return true;
      }
      return REGEX.isPhone.test(phone);
    },
    checkFaxValidity(fax) {
      if (!fax) {
        return true;
      }
      return REGEX.isFax.test(fax);
    }
  },
  validations() {
    return {
      copy: {
        firstName: { required },
        lastName: { required },
        workTitle: { required },
        companyLocationId: { required },
        workEmail: { required, email },
        workPhone1: {
          required,
          isValidPhone(workPhone1) {
            if (!workPhone1) {
              return false;
            }
            return REGEX.isPhone.test(workPhone1);
          }
        },
        workPhone1TypeId: {
          required,
          isValidPhoneType(workPhone1Type) {
            if (!workPhone1Type) {
              return false;
            }
            return true;
          }
        },
        phoneNumber: {
          isValidPhone(phoneNumber) {
            return this.phoneValidation(phoneNumber);
          }
        },
        phone2: {
          isValidPhone(phone2) {
            return this.phoneValidation(phone2);
          }
        },
        workPhone2: {
          isValidPhone(workPhone2) {
            return this.phoneValidation(workPhone2);
          }
        },
        workPhone2TypeId: {
          isValidPhoneType(workPhone2Type) {
            if (!this.copy.workPhone2) {
              return true;
            }
            if (!workPhone2Type) {
              return false;
            }
            return true;
          }
        },
        fax: {
          isValidFax(fax) {
            return this.checkFaxValidity(fax);
          }
        },
        workFax: {
          isValidFax(workFax) {
            return this.checkFaxValidity(workFax);
          }
        },
        zipcode: {
          isValidZipCode(zipcode) {
            if (!zipcode) {
              return true;
            }
            return zipcode.length >= 5;
          }
        },
        email2: { email },
        workEmail2: { email },
        email: { email }
      },
      selectedContactRoles: { required }
    };
  },
  async created() {
    this.setFormValues();
  }
};
</script>

<style scoped>
.form-width-default {
  width: 200px;
}

.form-width-small {
  width: 70px;
}
</style>